import { render, staticRenderFns } from "./permissionDenied.vue?vue&type=template&id=124ab408&"
import script from "./permissionDenied.vue?vue&type=script&lang=js&"
export * from "./permissionDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports